import type { ReactNode } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'

import { getLocalizedPath, isLocale } from '@/content/i18n'
import { dashboardCopy } from '@/content/dashboardContent'
import { useAuth } from '@/hooks/useAuth'
import { getLocalizedValue } from '@/lib/utils'
import type { Locale } from '@/types/site'

type RequireAuthProps = {
  children: ReactNode
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { isAuthenticated, userLoading, token } = useAuth()
  const { locale: localeParam } = useParams<{ locale: string }>()
  const location = useLocation()

  if (!isLocale(localeParam)) {
    return null
  }

  const locale = localeParam as Locale

  if (!isAuthenticated) {
    return <Navigate to={getLocalizedPath(locale, 'auth/login')} replace state={{ from: location.pathname }} />
  }

  if (token && userLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-surface p-8 text-sm text-slate-500">
        {getLocalizedValue(dashboardCopy.loadingDashboard, locale)}
      </div>
    )
  }

  return children
}
